import React from 'react';
import Button from '@material-ui/core/Button';
import ChevronLeftIcon from 'material-ui/svg-icons/navigation/chevron-left';
import './ScorecardChooserOverrideNav.styl';

export const overrideName = 'ScorecardChooserOverride';

export default class ScorecardChooserOverrideNav extends React.Component {
  render() {
    if (!this.props) return;

    const {goBack} = this.props;

    return (
      <div className="chooser-header">
        <div className="wrapper">
          <Button variant="text" className="ev-button" onClick={() => goBack()}>
            <ChevronLeftIcon />
            Back To Call
          </Button>
        </div>
      </div>
    );
  }
}
